module.exports = "/images/image.png?760db19f711d54e559ce58d8c508f29e";